
/**
 * 업로드되는 미디어/자료의 컨텍스트 (예: 강의 전체 자료, 특정 강의의 마크다운 등)
 */
export type UploadEduMediaBodyAssetContext = typeof UploadEduMediaBodyAssetContext[keyof typeof UploadEduMediaBodyAssetContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadEduMediaBodyAssetContext = {
  COURSE_MATERIAL: 'COURSE_MATERIAL',
  LECTURE_MARKDOWN: 'LECTURE_MARKDOWN',
  LECTURE_VIDEO: 'LECTURE_VIDEO',
} as const;
